export default __webpack_public_path__ + "static/media/race-director-m-podium.73b00d31.png";